import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the auth callback (important for OAuth flows)
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error("Error during auth callback:", error);
          navigate("/login", {
            state: {
              error: "Authentication failed. Please try again.",
            },
          });
          return;
        }

        // Check if we have a valid session and user
        if (data.session && data.session.user) {
          console.log(
            "Auth callback successful, user authenticated:",
            data.session.user.id,
          );
          // Navigate to AI assistants with fromAuth state to trigger proper redirect logic
          navigate("/ai-assistants", {
            state: {
              fromAuth: true,
            },
          });
        } else {
          console.log("No valid session found in auth callback");
          navigate("/login");
        }
      } catch (error) {
        console.error("Unexpected error during auth callback:", error);
        navigate("/login", {
          state: {
            error: "An unexpected error occurred during authentication.",
          },
        });
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-4">Completing sign in...</h2>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
      </div>
    </div>
  );
}
